<div *ngIf="element" class="surveys-element-input-year" role="group">
  <surveys-element-question-text
    *ngIf="multipartQuestionHeader"
    [text]="multipartQuestionHeader"
    [textSize]="'small'"
    [classes]="['multipart-label']"
  ></surveys-element-question-text>
  <label for="element.id">
    <div class="label">
      <surveys-element-question-text
        [id]="element.id"
        [text]="element.label[language]"
        [required]="element.required"
      ></surveys-element-question-text>
    </div>

    <div class="inputs">
      <div class="input-element year">
        <r-masked-input
          [control]="control"
          [placeholder]="'YYYY'"
          [shouldFocus]="shouldFocus"
          [type]="'year'"
          [labeledby]="element.id"
          [describedby]="
            multipartQuestionId ? multipartQuestionId : null
          "
          (keyUp)="keyMonitor($event)"
          (blur)="handleOnBlur()"
        >
        </r-masked-input>
      </div>
    </div>
  </label>
  <div class="button-element">
    <r-button
      *ngIf="showProceedActions()"
      class="continue-button"
      [e2e]="'button-' + element.id + '-continue'"
      [affirmative]="true"
      [negative]="false"
      [describedby]="element.id"
      (onClick)="advance()"
    >
      {{ 'surveys.navigation.continue' | translate }}
    </r-button>
  </div>
</div>
